<template lang="html">
  <section class="overview" id="overview">
    <div class="mt-4 pt-2" v-if="preSearch && searchModel!=='tavnit'">הזן מילת חיפוש בשורת החיפוש</div>
    <div class="overview-heading" v-if="resultsNum > 0  && complete">
      <span v-if="searchModel==='rhyme'">{{hebrew ? ' סקירה כללית של חרוזים למילה' : 'General Overview'}}</span>
      <span v-if="searchModel==='xxsonance'">{{hebrew ? ' סקירה כללית של מילים המצטלצלות עם' : 'General Overview'}}</span>
      <span v-if="searchModel==='alliteration'">{{hebrew ? ' סקירה כללית של מילים בעלות אליטרציה התואמת למילה' : 'General Overview'}}</span>
      <span v-if="searchModel==='tavnit'">{{hebrew ? ' סקירה כללית של מילים בעלות תבנית מילה תואמת' : 'General Overview'}}</span>
      <h3 class="f-narkis d-inline mx-1">{{searchWord}}</h3>
    </div>
    <AllResults  @rhymeResultsCount="setNumResults"/> 
    <!-- <TavnitResults v-else />  -->
  </section>
</template>
<script lang="js">
  import AllResults from '@/components/AllResults'
 // import TavnitResults from '@/components/TavnitResults'
  import {RunStates} from '@/store/runStates'
  export default  {
    name: 'Overview',
    components: {AllResults},
    data() {
      return {
        resultsNum: 0
      }
    },
    methods: {
      setNumResults (val) {
        this.resultsNum = val
      }         
    },
    mounted() {
     
    },
    computed: {
      searchWord () {
        return this.$store.state.textForCharuzitApiCall
      },
      preSearch () {
        return this.$store.state.charuzitApiState === RunStates.NOT_RUN && this.searchWord === ''
      },      
      complete () {
        return this.$store.state.charuzitApiState === RunStates.COMPLETE
      },
      searchModel () {
        return this.$store.state.searchModel
      },
      hebrew () {
        return this.$settings.hebrew
      }
    }
  }
</script>